import React from 'react';
import { IconWrapper } from '../runtime';
export default IconWrapper('arrow-right-one', false, function (props) {
  return /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 16 16",
    width: props.size,
    height: props.size
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.12835293,3.16551763 C5.29255694,2.98306874 5.56059534,2.94964961 5.76228938,3.07421703 L5.83448237,3.12835293 L10.8344824,7.62835293 C11.0306514,7.80490507 11.052448,8.09794564 10.899872,8.3003841 L10.8344824,8.37164707 L5.83448237,12.8716471 C5.62922736,13.0563766 5.31308244,13.0397374 5.12835293,12.8344824 C4.96414892,12.6520335 4.95905106,12.3819679 5.10410256,12.1944643 L5.16551763,12.1283529 L9.752,7.999 L5.16551763,3.87164707 C4.98306874,3.70744306 4.94964961,3.43940466 5.07421703,3.23771062 L5.12835293,3.16551763 Z",
    fillRule: "nonzero",
    fill: props.colors[0]
  }));
});